import { useEffect, useState } from "react";

type Tema = "claro" | "escuro";
// Fora do prefixo "caixaflow:" de propósito: a preferência visual sobrevive ao "Sair".
const CHAVE = "caixaflow-tema";
const sistemaEscuro = () => window.matchMedia("(prefers-color-scheme: dark)");

function escolhido(): Tema | null {
  try {
    const t = localStorage.getItem(CHAVE);
    return t === "claro" || t === "escuro" ? t : null;
  } catch {
    return null;
  }
}

const atual = (): Tema => escolhido() ?? (sistemaEscuro().matches ? "escuro" : "claro");

function aplicar(tema: Tema) {
  document.documentElement.dataset.theme = tema === "escuro" ? "dark" : "light";
  document
    .querySelectorAll('meta[name="theme-color"]')
    .forEach((m) => m.setAttribute("content", tema === "escuro" ? "#0E1222" : "#F3F5FA"));
  try {
    localStorage.setItem(CHAVE, tema);
  } catch {
    // sem armazenamento: vale só até recarregar
  }
}

/** Alterna entre modo claro e escuro. Sem escolha salva, começa seguindo o tema do aparelho. */
export function BotaoTema({ className = "" }: { className?: string }) {
  const [tema, setTema] = useState<Tema>(atual);

  useEffect(() => {
    // Enquanto o usuário não escolheu, acompanha o tema do aparelho (ex.: modo noturno automático).
    const midia = sistemaEscuro();
    const mudou = () => {
      if (!escolhido()) setTema(midia.matches ? "escuro" : "claro");
    };
    midia.addEventListener("change", mudou);
    return () => midia.removeEventListener("change", mudou);
  }, []);

  const proximo: Tema = tema === "escuro" ? "claro" : "escuro";
  const rotulo = proximo === "escuro" ? "Mudar para modo escuro" : "Mudar para modo claro";
  return (
    <button
      type="button"
      className={`botao-tema ${className}`}
      aria-label={rotulo}
      title={rotulo}
      onClick={() => {
        aplicar(proximo);
        setTema(proximo);
      }}
    >
      {tema === "escuro" ? <IconeSol /> : <IconeLua />}
    </button>
  );
}

function IconeSol() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <circle cx="12" cy="12" r="4.5" />
      <path d="M12 2v2.5M12 19.5V22M4.2 4.2l1.8 1.8M18 18l1.8 1.8M2 12h2.5M19.5 12H22M4.2 19.8 6 18M18 6l1.8-1.8" />
    </svg>
  );
}

function IconeLua() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" aria-hidden="true">
      <path d="M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5a8.5 8.5 0 1 0 11 11z" />
    </svg>
  );
}
